import { jsx as c } from "react/jsx-runtime";
import u from "clsx";
import { Slot as g } from "@radix-ui/react-slot";
import { forwardRef as d } from "react";
import '../../assets/flex.css';const j = "_flex_1y3tl_1", e = {
  flex: j,
  "flex--row": "_flex--row_1y3tl_5",
  "flex--row-reverse": "_flex--row-reverse_1y3tl_9",
  "flex--column": "_flex--column_1y3tl_13",
  "flex--column-reverse": "_flex--column-reverse_1y3tl_17",
  "flex--justify-start": "_flex--justify-start_1y3tl_21",
  "flex--justify-end": "_flex--justify-end_1y3tl_25",
  "flex--justify-center": "_flex--justify-center_1y3tl_29",
  "flex--justify-between": "_flex--justify-between_1y3tl_33",
  "flex--justify-around": "_flex--justify-around_1y3tl_37",
  "flex--justify-evenly": "_flex--justify-evenly_1y3tl_41",
  "flex--align-start": "_flex--align-start_1y3tl_45",
  "flex--align-end": "_flex--align-end_1y3tl_49",
  "flex--align-center": "_flex--align-center_1y3tl_53",
  "flex--align-stretch": "_flex--align-stretch_1y3tl_57",
  "flex--gap-xs": "_flex--gap-xs_1y3tl_61",
  "flex--gap-sm": "_flex--gap-sm_1y3tl_65",
  "flex--gap-md": "_flex--gap-md_1y3tl_69",
  "flex--gap-lg": "_flex--gap-lg_1y3tl_73",
  "flex--gap-xl": "_flex--gap-xl_1y3tl_77",
  "flex--wrap-nowrap": "_flex--wrap-nowrap_1y3tl_81",
  "flex--wrap-wrap": "_flex--wrap-wrap_1y3tl_85",
  "flex--wrap-wrap-reverse": "_flex--wrap-wrap-reverse_1y3tl_89",
  "flex-grow": "_flex-grow_1y3tl_98",
  "flex-shrink": "_flex-shrink_1y3tl_107",
  "flex-direction-sm-column": "_flex-direction-sm-column_1y3tl_111",
  "flex-direction-sm-row": "_flex-direction-sm-row_1y3tl_124"
}, C = d(
  ({
    asChild: t,
    direction: r = "row",
    reverse: x,
    className: m = "",
    justify: l,
    align: _,
    children: i,
    gap: f,
    wrap: n,
    grow: s,
    shrink: o,
    directionSm: a,
    ...y
  }, p) => /* @__PURE__ */ c(
    t ? g : "div",
    {
      className: u(
        {
          [e.flex]: !0,
          [e["flex--row-reverse"]]: x && r === "row",
          [e["flex--column-reverse"]]: x && r === "column",
          [e["flex--row"]]: !x && r === "row",
          [e["flex--column"]]: !x && r === "column",
          [e["flex--justify-start"]]: l === "start",
          [e["flex--justify-end"]]: l === "end",
          [e["flex--justify-center"]]: l === "center",
          [e["flex--justify-between"]]: l === "between",
          [e["flex--justify-around"]]: l === "around",
          [e["flex--justify-evenly"]]: l === "evenly",
          [e["flex--align-start"]]: _ === "start",
          [e["flex--align-end"]]: _ === "end",
          [e["flex--align-center"]]: _ === "center",
          [e["flex--align-stretch"]]: _ === "stretch",
          [e["flex--gap-xs"]]: f === "xs",
          [e["flex--gap-sm"]]: f === "sm",
          [e["flex--gap-md"]]: f === "md",
          [e["flex--gap-lg"]]: f === "lg",
          [e["flex--gap-xl"]]: f === "xl",
          [e["flex--wrap-nowrap"]]: n === "nowrap",
          [e["flex--wrap-wrap"]]: n === "wrap",
          [e["flex--wrap-wrap-reverse"]]: n === "wrap-reverse",
          [e["flex-grow"]]: w(s),
          [e["flex-shrink"]]: w(o),
          [e["flex-direction-sm-column"]]: a === "column",
          [e["flex-direction-sm-row"]]: a === "row"
        },
        m
      ),
      ...y,
      style: {
        "--grow-factor": s,
        "--shrink-factor": o,
        ...y.style
      },
      ref: p,
      children: i
    }
  )
), w = (t) => typeof t == "number" && !isNaN(t);
export {
  C as Flex
};
